import type { StreamingMessage } from "./message-utils";

export function AgentStreamingMessage({
  message,
}: {
  message: StreamingMessage;
}) {
  return (
    <article
      aria-label="Streaming message from agent"
      aria-live="polite"
      className="flex min-w-0 justify-start"
    >
      <div className="min-w-0 max-w-[88%] rounded-2xl rounded-bl-md border border-slate-200 bg-white px-4 py-3 text-slate-800 text-sm shadow-xs md:max-w-[75%]">
        <div className="mb-2 flex items-center gap-2 text-slate-500 text-xs">
          <span className="font-medium">Agent</span>
          <span aria-hidden="true" className="animate-pulse">
            Responding…
          </span>
        </div>
        <p className="whitespace-pre-wrap [overflow-wrap:anywhere]">
          {message.text}
        </p>
      </div>
    </article>
  );
}
